import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useFormContext } from '../Form';
import useRegisterInput from '../Form/useRegisterInput';

const TextEditor = ({ name, value, onChange, onBlur, register: shouldRegister }) => {
  useRegisterInput(name, shouldRegister);

  const formContext = useFormContext();
  const { setValue, watch } = formContext || {};
  const parsedProps = {
    value: value || watch(name),
  };
  const [contentState, setContentState] = useState(parsedProps.value);

  /**
   * Handle the change on the text editor.
   * @param {string} content
   */
  const handleOnChange = content => {
    setContentState(content);

    if (formContext && !onChange) {
      setValue(name, content);
      return;
    }

    if (onChange) {
      onChange(content);
    }
  };

  useEffect(() => {
    setContentState(parsedProps.value);
  }, [parsedProps.value]);

  return <ReactQuill value={contentState} theme="snow" onChange={handleOnChange} onBlur={onBlur} />;
};

TextEditor.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  register: PropTypes.bool,
};

TextEditor.defaultProps = {
  value: '',
  onChange: undefined,
  onBlur: undefined,
  register: true,
};

export default TextEditor;
